import { memo } from "react";

function ProjectCard({
  project,
  onOpen,
  loading = "lazy",
  fetchPriority = "auto",
  isInteractive = true,
}) {
  const handleOpen = () => {
    if (!isInteractive) return;
    onOpen(project);
  };

  const handleKeyDown = (event) => {
    if (!isInteractive) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onOpen(project);
    }
  };

  return (
    <button
      type="button"
      className="main__card"
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      tabIndex={isInteractive ? 0 : -1}
      aria-hidden={!isInteractive}
      data-project={project.id}
      data-project-name={project.name}
      data-interactive={isInteractive ? "true" : "false"}
    >
      <span className="main__card-media">
        <img
          className="main__card-image"
          src={project.image}
          alt={project.imageAlt || project.name}
          width={project.imageWidth ?? 1200}
          height={project.imageHeight ?? 675}
          loading={loading}
          decoding="async"
          fetchPriority={fetchPriority}
        />
      </span>

      <span className="main__card-content">
        <span className="main__card-title">{project.name}</span>
        <span className="main__card-description">{project.description}</span>
      </span>
    </button>
  );
}

export default memo(ProjectCard);
